<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
        <h6 class="mb-0 me-auto">Lista de citas</h6>
        <router-link
          :to="{ name: 'Appointment Create' }"
          class="btn btn-sm btn-primary text-white"
          title="Agregar cita"
        >
          <i class="fa fa-plus me-1"></i> Agregar
        </router-link>
      </div>
      <div class="row">
        <!-- Columna de búsqueda -->
        <div class="col-md-6 mb-3">
          <label for="searchQuery" class="mb-1">Buscar</label>
          <input 
            type="text" 
            v-model="searchQuery" 
            id="searchQuery"
            class="form-control" 
            placeholder="Buscar cita..." 
            @input="fetchData(null)" 
          />
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Email</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Teléfono</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha cita</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Estado</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="user in users" :key="user.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <!-- <div>
                    <img
                      src="../../../assets/img/team-2.jpg"
                      class="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div> -->
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ user.full_name }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ user.document }}</p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <p class="text-xs text-secondary mb-0">{{ user.email }}</p>
              </td>
              
              <td class="align-middle text-center text-sm">
                <p class="text-xs text-secondary mb-0">{{ user.phone }}</p>         
              </td>
              
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ new Date(user.date + 'T00:00:00').toLocaleDateString('es-ES') }} 
                </span>
              </td>

              <td class="align-middle text-center text-sm">
                <span 
                  class="badge badge-sm"
                  :class="{
                    'bg-gradient-warning': user.status === 0, // Programada
                    'bg-gradient-success': user.status === 1, // Asistida
                    'bg-gradient-danger': user.status === 2   // Cancelada
                  }"
                >
                  {{ 
                    user.status === 0 ? 'Programada' : 
                    user.status === 1 ? 'Asistida' : 
                    'Cancelada' 
                  }}
                </span>
              </td>


              <td class="align-middle text-center">

                
                <a
                  @click="toggleStatus(user)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer"
                  data-toggle="tooltip"
                  data-original-title="Cambiar Estado"
                >
                  <i class="fa fa-calendar-check"></i>
                </a>

                <a
                  @click="appointmentPdf(user.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer " style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar usuario"
                >
                <i class="fa fa-file"></i>
              </a>
                
                <router-link 
                  :to="{ name: 'Appointment Create', params: { data: JSON.stringify(user) } , props: true }"  style="margin-left: 15px;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Agregar usuario"
                >
                <i class="fa fa-pencil-alt"></i>
                </router-link>
                <a
                  @click="deleteUser(user.id)" 
                  class="text-secondary font-weight-bold text-xs cursor-pointer " style="margin-left: 15px;"
                  data-toggle="tooltip"
                  data-original-title="Eliminar usuario"
                >
                <i class="fa fa-trash"></i>
              </a>

            

              </td>
            </tr>
           
            <tr v-if="users.length === 0">
              <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
            </tr>
          </tbody>
        </table>
    
      

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
              :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>
    </div>

  </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'UserList',
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('optometryRecords', ['allData', 'currentPage', 'lastPage', 'links']), // Mapea el getter allUsers
    currentPage() {
        return this.$store.state.optometryRecords.currentPage; // Obtiene la página actual
    },
    lastPage() {
        return this.$store.state.optometryRecords.lastPage; // Obtiene la última página
    },
    users() {
        return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['optometryRecords/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      let params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1        
      }
      await this.$store.dispatch('optometryRecords/fetchData',params); 
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("optometryRecords/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async toggleStatus(data) {
      const result = await Swal.fire({
        title: "Actualizar estado",
        text: "¿Deseas marcar la cita como Asistida o Cancelada?",
        icon: "question",
        showDenyButton: true, // Permite dos botones con funciones separadas
        showCancelButton: false, // Permite cerrar sin elegir
        confirmButtonText: "Asistida",
        denyButtonText: "Cancelada",
        confirmButtonColor: "#28a745", // Verde para Asistida
        denyButtonColor: "#dc3545", // Rojo para Cancelada
        cancelButtonColor: "#6c757d", // Gris para cerrar
      });

      // Verifica qué opción eligió el usuario
      if (result.isConfirmed) {
        data.status = 1; // Asistida
      } else if (result.isDenied) {
        data.status = 2; // Cancelada
      } else {
        return; // No hacer nada si se cerró sin elegir
      }

      try {
        // Dispara la acción de Vuex para guardar el cambio
        const response = await this.$store.dispatch("optometryRecords/save", data);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: "El estado de la cita ha sido actualizado correctamente.",
            confirmButtonText: "Aceptar",
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: "Appointment" });
            }
          });
        } else {
          throw new Error(response.data.message || "Error al actualizar el estado.");
        }
      } catch (error) {
        console.error("Error al actualizar el estado:", error);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Error al actualizar el estado.",
        });
      }
    },
    async appointmentPdf(id) {
      try {
          const response = await this.$store.dispatch("optometryRecords/getPdf", id);

          // Crear una URL del archivo recibido
          const url = window.URL.createObjectURL(new Blob([response]));

          // Crear un enlace para descargar el archivo
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Cita_${id}.docx`); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar la URL creada
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
      } catch (error) {
          console.error("Error al descargar el archivo:", error);
      }
  }

  },
  mounted() {
    this.fetchData(); 
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>